exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-danger2[data-v-0e50615a]{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.riseup-mp[data-v-0e50615a]{border-color:#fe9900!important;border-width:7px!important}.riseup-turismo[data-v-0e50615a]{border-color:#263d81!important}.riseup-tindahan[data-v-0e50615a],.riseup-turismo[data-v-0e50615a]{border-width:7px!important}.bg-none[data-v-0e50615a]{background-color:transparent!important}.bl[data-v-0e50615a]{color:#000}.bg-gray[data-v-0e50615a]{background-color:#f3f3f3!important}.bg-gray2[data-v-0e50615a]{background-color:#e5e5e5!important}", ""]);

// exports
